export default __webpack_public_path__ + "static/media/clue1.38d18053.png";